import React, { useEffect, useState } from "react";
import {
  Container,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import CachedIcon from "@material-ui/icons/Cached";
import ChatIcon from "@material-ui/icons/Chat";
import MaterialTable, { MTableToolbar } from "material-table";
import { connect } from "react-redux";
import {
  addOtcManualProductAction,
  addPhysicalInventoryRxAction,
  addPhysicalInventoryRxOtcWithoutLotNoAction,
  addPhysicalInventoryManualRxAction,
} from "../../../../../store/inventory/actions";
import { editPhysicalInventoryAction } from "../../../../../store/physicalInventory/actions";
import { getSessionData } from "../../../base/helper/baseHelper";
import CommentPopup from "../../../base/views/CommentPopup";
import ConfirmationDialog from "../../../base/views/ConfirmationDialog";
import Popup from "../../../base/views/Popup";
import LandingPageFooter from "../../../LandingPage/views/LandingPageFooter";
import { GetUpcDetailsFromBarcode } from "../../CaptureReceivedGoods/helper/CaptureReceivedGoodsHelper";
import {
  addPhysicalInventoryWithoutLotNo,
  DeletePhysicalInventoryStage,
  GetCommentsPhysicalInventory,
  getPhysicalInventories_without_lot_no,
  submitPhysicalInventory,
  UpdateCommentsPhysicalInventory,
  UpdateStagePhysicalInventory,
  getUPCdetailPhysicalInventory,
  deletePhysicalInventoryWithoutLot,
} from "../helper/physicalInventoryHelper";
import AddManualOtcProductForm from "./AddManualOtcProductForm";
import GoodReceivablePhysicalInventoryForm from "./GoodReceivablePhysicalInventoryForm";
import PhysicalInventoryForm from "./PhysicalInventoryForm";
import AddOtcProductForm from "./AddOtcProductForm";
import AddRxProductForm from "./AddRxProductForm";
import { CalculateUpcFromBarcode } from "../../CaptureReceivedGoods/helper/CaptureReceivedGoodsHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },

  pricingheader: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: 400,
    width: "100%",
    maxWidth: 195,
    position: "relative",
    borderRadius: 16,
    display: "flex",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    flexDirection: "column",
    paddingTop: 4,
    paddingBottom: 4,
    "&:last-child": {
      paddingRight: 5,
    },
    flexShrink: 0,
    marginRight: theme.spacing(5),
  },
  cardPricing: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginBottom: theme.spacing(2),
  },
  cardHeader: {
    fontSize: "small",
  },
  cardpaidlist: {
    paddingTop: 5,
    justifyContent: "center",
    paddingLeft: 10,
  },
  cardpaid: {
    paddingTop: 2,
    paddingLeft: 2,
    fontSize: "small",
    justifyContent: "center",
  },
  planswitcher: {
    paddingBottom: 12,
    paddingTop: 4,
  },
  showallplan: {
    paddingBottom: 12,
    paddingTop: 10,
    justifyContent: "center",
    display: "flex",
  },
  cardpaidlisticon: {
    position: "relative",
    top: 8,
  },
  gridlisticon: {
    position: "relative",
    left: 25,
  },
  appBar: {
    backgroundColor: "rgba(255,255,255,0.5)",
  },
  title: {
    flexGrow: 1,
    color: "rgba(0, 0, 0, 0.7);",
  },
  labels: {
    width: "90%",
    padding: "0.4rem 0rem",
    fontSize: "1rem",
    justifyContent: "space-between",
  },
  plantable: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantable2: {
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(6px)",
    marginBottom: "1%",
  },
  plantableheader: {
    alignItems: "center",
    display: "inline-flex",
    flexWrap: "Wrap",
    justifyContent: "left",
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
    backgroundColor: "rgba(255,255,255,0.5)",
    backdropFilter: "blur(8px)",
    width: "100%",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const initialFValues = {
  physicalInventoryId: 0,
  location: "",
  barcode: "",
  ndc: "",
  packs: 1,
  description: "",
  packsize: "",
};

function PhysicalInventoryLandingPageWithoutLotNo(props) {
  const classes = useStyles();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [errors, setErrors] = React.useState({});
  const [openPopup, setOpenPopup] = useState(false);
  const [physicalInventoryData, setPhysicalInventoryData] = useState(
    initialFValues
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [previousLocation, setPreviousLocation] = useState("");
  const [openLocationDialog, setOpenLocationDialog] = useState(false);
  const [
    openReceivedInventoriesDialog,
    setOpenReceivedInventoriesDialog,
  ] = useState(false);
  const [openDoubleConfirmDialog, setOpenDoubleConfirmDialog] = useState(false);
  const [deletePhysicalInventoryObj, setDeletePhysicalInventoryObj] = useState(
    []
  );
  const [gridData, setGridData] = useState([]);
  const [storeId, setStoreId] = useState("");
  const [userId, setUserId] = useState("");
  const [openCommentPopup, setOpenCommentPopup] = useState(false);
  const [ndc, setNdc] = useState("");
  const [comment, setComment] = useState("");
  const [enableComment, setEnableComment] = useState(false);
  const [recordForEditForManualOTC, setRecordForEditForManualOTC] = useState(
    null
  );
  const [recordForEditForManualRx, setRecordForEditForManualRx] = useState(
    null
  );
  const [openManualOTCPopup, setOpenManualOTCPopup] = useState(false);
  const [openOTCManualDialog, setOpenOTCManualDialog] = useState(false);
  const [previousBarCode, setPreviousBarCode] = useState("");
  const [openOTCPopup, setOpenOTCPopup] = useState(false);
  const [recordForEditOTC, setRecordForEditForOTC] = useState(null);
  const [openRxDialog, setOpenRxDialog] = useState(false);
  const [recordForEditForRx, setRecordForEditForRx] = useState(null);
  const [openRxPopup, setOpenRxPopup] = useState(false);

  const locationRef = React.useRef();
  const barcodeRef = React.useRef();

  const {
    physicalInventories,
    editPhysicalInventory,
    addOtcManualProduct,
    addPhysicalInventory,
    addPhysicalInventoryOtcRxProduct,
    addRxProduct,
    setShowLastPriceModifiedPopup,
  } = props;

  useEffect(() => {
    setGridData([]);
    setUserId(getSessionData({ key: "userId" }));
    const store = JSON.parse(getSessionData({ key: "store" }));
    setStoreId(store.storeid);
    if (storeId) {
      GetPhysicalInventories();
    }
    //eslint-disable-next-line
  }, [userId, storeId, getPhysicalInventories_without_lot_no]);

  useEffect(() => {
    if (physicalInventories.length > 0 && physicalInventories[0].ndc != null) {
      setGridData(physicalInventories);
      setPhysicalInventoryData({
        ...physicalInventoryData,
        barcode: "",
      });
    } else {
      locationRef.current.focus();
    }
    //eslint-disable-next-line
  }, [physicalInventories]);

  useEffect(() => {
    if (openOTCManualDialog) {
      onOTCManualOkButtonClick();
    } else {
      onOTCManualCancelButtonClick();
    }

    // eslint-disable-next-line
  }, [openOTCManualDialog]);

  const GetUPCdetailPhysicalInventory = async () => {
    try {
      const store = JSON.parse(getSessionData({ key: "store" }));
      await getUPCdetailPhysicalInventory(store?.storeid);
    } catch (error) {}
  };

  const onOTCManualOkButtonClick = () => {
    const index = physicalInventoryData.barcode?.indexOf("*");
    const barcode = physicalInventoryData.barcode
      ? index
        ? physicalInventoryData.barcode.substring(index + 1)
        : physicalInventoryData.barcode
      : previousBarCode;
    setRecordForEditForManualOTC({
      upc: barcode,
      ndc: "",
      strength: "",
      description: "",
      packsize: "",
      manufacturename: "",
      nonreturnable: "",
      formula: "",
      dcqty: "",
    });
  };

  const onOTCManualCancelButtonClick = () => {
    const index = physicalInventoryData.barcode?.indexOf("*");
    const barcode = physicalInventoryData.barcode
      ? index
        ? physicalInventoryData.barcode.substring(index + 1)
        : physicalInventoryData.barcode
      : previousBarCode;
    setRecordForEditForManualRx({
      barcode: barcode,
      name: "",
      strength: "",
      dosageform: "",
      packsize: "",
      ndc: "",
      upc: barcode,
      user_id: userId,
      store_id: storeId,
      location: physicalInventoryData.location,
    });
  };

  const GetPhysicalInventories = () => {
    if (userId !== "" && storeId !== "") {
      const data = {
        store_id: storeId,
        user_id: userId,
      };
      getPhysicalInventories_without_lot_no(data)
        .then((response) => {
          if (response?.data?.length === 0) setShowLastPriceModifiedPopup(1);
          else setShowLastPriceModifiedPopup(null);
          if (response && response.data && response.data.length > 0) {
            setGridData(response.data);
            barcodeRef.current.focus();
            setPhysicalInventoryData({
              ...physicalInventoryData,
              barcode: "",
            });
            setOpenReceivedInventoriesDialog(true);
          } else {
            locationRef.current.focus();
          }
        })
        .catch((err) => {});
    }
  };

  const validate = (fieldValues = physicalInventoryData) => {
    let temp = { ...errors };

    if ("barcode" in fieldValues) {
      temp.barcode = fieldValues.barcode === "" ? "Barcode is required" : "";
    }

    if ("location" in fieldValues) {
      temp.location = fieldValues.location === "" ? "Location is required" : "";
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const onOTCOkButtonClick = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      barcode: physicalInventoryData.barcode,
    };

    GetUpcDetailsFromBarcode(data).then((upcDetailResponse) => {
      if (upcDetailResponse === undefined) {
        setOpenOTCManualDialog(true);
        setOpenManualOTCPopup(true);
        setPreviousBarCode(physicalInventoryData.barcode);
      } else {
        setRecordForEditForOTC({
          otc: true,
          withlotno: false,
          user_id: userId,
          store_id: storeId,
          description: upcDetailResponse.description,
          ndc: upcDetailResponse.ndc,
          packsize: upcDetailResponse.packsize,
          upc: upcDetailResponse.upc,
          serialno: "",
          expirydate: null,
          lot: "",
          qty: "1",
          location: physicalInventoryData.location,
          comments: "",
          labeller_name: upcDetailResponse.labeler_name,
          inv_type: "FULL",
        });
        setOpenOTCManualDialog(false);
        setOpenOTCPopup(true);
        setPhysicalInventoryData((prevState) => ({
          ...prevState,
          barcode: "",
        }));
      }
    });
  };

  const onRxOkButtonClick = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      barcode: physicalInventoryData.barcode,
    };
    GetUpcDetailsFromBarcode(data).then((upcDetailResponse) => {
      if (upcDetailResponse !== undefined) {
        setOpenRxDialog(false);
        setRecordForEditForRx({
          withlotno: false,
          otc: false,
          user_id: userId,
          store_id: storeId,
          description: upcDetailResponse.description,
          ndc: upcDetailResponse.ndc,
          packsize: upcDetailResponse.packsize,
          upc: upcDetailResponse.upc,
          serialno: "",
          expirydate: null,
          lot: "",
          qty: "1",
          location: physicalInventoryData.location,
          comments: "",
          labeller_name: upcDetailResponse.labeler_name,
        });
        setOpenRxPopup(true);
      } else {
        setOpenRxDialog(false);
        setOpenRxPopup(false);
      }
      setPhysicalInventoryData((prevState) => ({
        ...prevState,
        barcode: "",
      }));
    });
  };

  const onOkButtonClick = () => {
    CalculateUpcFromBarcode(physicalInventoryData.barcode).then((response) => {
      setOpenDialog(false);
      setPreviousBarCode("");
      setRecordForEditForManualRx({
        barcode: physicalInventoryData.barcode,
        name: "",
        strength: "",
        dosageform: "",
        packsize: "",
        ndc: "",
        upc: response,
      });
      setOpenManualOTCPopup(true);
      setPhysicalInventoryData({
        ...physicalInventoryData,
        barcode: "",
      });
    });
  };

  const Scan = (e) => {
    if (e.target.id === "barcode" && (e.type === "click" || e.which === 13)) {
      if (validate()) {
        addPhysicalInventoryWithoutLotNo({
          user_id: userId,
          store_id: storeId,
          location: physicalInventoryData.location,
          barcode: physicalInventoryData.barcode,
        }).then((response) => {
          if (response && response.data.length > 0) {
            setGridData(response.data);
            setPhysicalInventoryData((prevState) => ({
              ...prevState,
              barcode: "",
            }));
          } else if (response.error[0].message === "OTC Product") {
            onOTCOkButtonClick();
            setPreviousBarCode("");
          } else if (response.error[0].message === "Rx OTC Product") {
            setOpenRxDialog(true);
            setPreviousBarCode("");
          } else if (response.error[0].message === "Invaid UPC Number") {
            setOpenDialog(true);
          }
        });

        setPreviousLocation(physicalInventoryData.location);

        // setPhysicalInventoryData({
        //   ...physicalInventoryData,
        //   barcode: "",
        //   ndc: "",
        //   description: "",
        //   packs: 1,
        //   packsize: null,
        // });
      }
    }
  };

  const handleChecked = (e) => {
    if (e.target.value === "OTC") {
      setOpenOTCManualDialog(true);
    } else if (e.target.value === "RX") {
      setOpenOTCManualDialog(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPhysicalInventoryData({
      ...physicalInventoryData,
      [name]: value,
    });
  };

  const HandleSubmitToPhysicalInventory = async (e) => {
    e.preventDefault();
    if (gridData && gridData.length > 0) {
      submitPhysicalInventory({
        store_id: storeId,
        user_id: userId,
      }).then((response) => {
        if (response) setGridData([]);
        setPreviousLocation("");
        setPhysicalInventoryData({
          ...physicalInventoryData,
          barcode: "",
          location: "",
          looseQty: "",
          comments: "",
          // partialfull: "FULL",
        });
        locationRef.current.focus();
      });
    }
  };

  const addOrEdit = (resetForm) => {
    resetForm();
    setRecordForEditForManualRx(null);
    setOpenPopup(false);
  };

  const addOrEditOTC = (resetForm) => {
    resetForm();
    setRecordForEditForOTC(null);
    setOpenOTCPopup(false);
  };

  const addOrEditForRx = (resetForm) => {
    resetForm();
    setRecordForEditForRx(null);
    setOpenRxPopup(false);
  };

  const openInPopup = (item) => {
    setRecordForEdit(item[0]);
    setOpenManualOTCPopup(true);
  };

  const onDeleteOkButtonClick = (rowData) => {
    let data = {
      store_id: storeId,
      user_id: userId,
      ndc: rowData.ndc,
      upc: rowData.upc,
    };
    setDeletePhysicalInventoryObj(data);
    setOpenDeleteDialog(true);
  };

  const handleDelete = async () => {
    setOpenDeleteDialog(false);
    try {
      await deletePhysicalInventoryWithoutLot(deletePhysicalInventoryObj);
      const { ndc, upc } = deletePhysicalInventoryObj;
      const data = gridData.filter((gd) => {
        return !(ndc === gd.ndc && upc === gd.upc);
      });
      setGridData(data);
      setDeletePhysicalInventoryObj([]);
    } catch (error) {}
  };

  const locationonBlur = (e) => {
    if (
      previousLocation &&
      e.target.value &&
      e.target.value !== previousLocation
    ) {
      setOpenLocationDialog(true);
    }
  };

  const onLocationOkButtonClick = () => {
    const data = {
      user_id: userId,
      store_id: storeId,
      location: physicalInventoryData.location,
    };
    UpdateStagePhysicalInventory(data)
      .then((response) => {
        if (response && response.length > 0) {
          setGridData(response);
          setOpenLocationDialog(false);
          setPreviousLocation(response[response.length - 1].location);
          setPhysicalInventoryData({
            ...physicalInventoryData,
            // partialfull: "FULL",
            looseQty: "0",
            barcode: "",
          });
        }
      })
      .catch((err) => {});
  };

  const enableDoubleConfirm = () => {
    setOpenDoubleConfirmDialog(true);
  };

  const onReceivedInventoriesCancelClick = () => {
    barcodeRef.current.focus();
    setOpenReceivedInventoriesDialog(false);
    setOpenDoubleConfirmDialog(false);
    if (gridData && gridData.length > 0) {
      setPhysicalInventoryData({
        ...physicalInventoryData,
        location: gridData[gridData.length - 1].location,
      });
    }
  };

  const onReceivedInventoriesOkButtonClick = () => {
    setOpenReceivedInventoriesDialog(false);
    setOpenDoubleConfirmDialog(false);
    var data = {
      user_id: userId,
      store_id: storeId,
    };
    DeletePhysicalInventoryStage(data)
      .then((response) => {
        setGridData([]);
        setPhysicalInventoryData({
          ...physicalInventoryData,
          location: "",
          barcode: "",
        });
        setPreviousLocation("");
        locationRef.current.focus();
      })
      .catch((err) => {});
  };

  const handleCommentSubmit = () => {
    var data = {
      user_id: userId,
      store_id: storeId,
      ndc: ndc,
      comment: comment,
    };
    UpdateCommentsPhysicalInventory(data)
      .then((response) => {
        setComment("");
        setOpenCommentPopup(false);
        setNdc("");
      })
      .catch((err) => {});
  };

  const getComments = (event, rowData) => {
    setNdc(rowData.ndc);
    GetCommentsPhysicalInventory({
      user_id: userId,
      store_id: storeId,
      ndc: rowData.ndc,
    }).then((response) => {
      if (response && response.length > 0) {
        setComment(response[0].message);
      }
      setOpenCommentPopup(true);
    });
  };

  const addOrEditForManualOTC = (resetForm) => {
    resetForm();
    setRecordForEditForManualOTC(null);
    setOpenManualOTCPopup(false);
    GetUPCdetailPhysicalInventory();
  };

  const addOrEditForManualRx = (resetForm) => {
    resetForm();
    setRecordForEditForManualRx(null);
    setOpenManualOTCPopup(false);
    GetUPCdetailPhysicalInventory();
  };

  return (
    <Container maxWidth={false}>
      <Grid container style={{ marginTop: "2.5%" }}>
        <Grid item xs={12} sm={4}>
          <TextField
            value={physicalInventoryData.location}
            onChange={handleInputChange}
            fullWidth
            id="location"
            label="Location"
            name="location"
            autoComplete="location"
            inputRef={locationRef}
            onBlur={locationonBlur}
            {...(errors.location && {
              error: true,
              helperText: errors.location,
            })}
          />
        </Grid>
        <Grid item sm={4} />
        <Grid item xs={12} sm={4}>
          <div tabIndex="-1" onKeyDown={Scan}>
            <TextField
              value={physicalInventoryData.barcode}
              onChange={handleInputChange}
              fullWidth
              id="barcode"
              label="Barcode"
              name="barcode"
              inputRef={barcodeRef}
              autoComplete="barcode"
              autoFocus
              {...(errors.barcode && {
                error: true,
                helperText: errors.barcode,
              })}
            />
          </div>
        </Grid>
      </Grid>
      {/* </Container> */}
      <div className={classes.root}>
        <MaterialTable
          title=""
          columns={[
            {
              title: "Description",
              field: "description",
              cellStyle: { width: "40%" },
            },
            { title: "NDC", field: "ndc", cellStyle: { width: "10%" } },
            { title: "Pack Size", field: "packsize" },
            {
              title: "Manufacturer",
              field: "manufacturer",
              cellStyle: { width: "20%" },
            },
            { title: "Full Qty", field: "fullquantity" },
            { title: "Partial Qty", field: "partialquantity" },
          ]}
          data={gridData}
          actions={[
            // {
            //   icon: "edit",
            //   tooltip: "Edit",
            //   disabled: true, // disabled temporarily since has dependancy on function.
            //   onClick: (event, rowData) => {
            //     openInPopup(rowData);
            //   },
            // },
            {
              icon: "delete",
              tooltip: "Delete",
              onClick: (event, rowData) => {
                onDeleteOkButtonClick(rowData);
              },
              position: "row",
            },
            {
              icon: () => <ChatIcon />,
              tooltip: "Comment",
              onClick: (event, rowData) => getComments(event, rowData),
              disabled: enableComment ? true : false,
              position: "row",
            },
          ]}
          options={{
            rowStyle: (rowData) => {
              if (rowData.expiryflag === "1") {
                return { backgroundColor: "#FFBF00" };
              } else if (rowData.expiryflag === "2") {
                return { backgroundColor: "rgb(244, 67, 54)" };
              }

              return {};
            },
            maxBodyHeight: 515,
            paging: true,
            pageSize: 25,
            pageSizeOptions: [25, 50, 100],
            headerStyle: {
              backgroundColor: "rgba(255,255,255,1)",
              color: "black",
            },
          }}
          components={{
            Toolbar: (props) => (
              <Box display="flex">
                <Box flexGrow={1}>
                  <MTableToolbar {...props} />
                </Box>
                <Box paddingBottom={1.5} paddingTop={2}>
                  <Button
                    onClick={(e) => {
                      HandleSubmitToPhysicalInventory(e);
                    }}
                    fullWidth={true}
                    color="primary"
                    variant="contained"
                    size="medium"
                    style={{
                      backgroundColor: "rgb(22, 177, 255)",
                      borderRadius: "0.5rem",
                    }}
                  >
                    Submit
                  </Button>
                </Box>
                <Tooltip title="Create New Session">
                  <IconButton
                    color="primary"
                    size="medium"
                    style={{ color: "rgb(22, 177, 255)" }}
                    onClick={() => {
                      setOpenReceivedInventoriesDialog(true);
                    }}
                  >
                    <CachedIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
            ),
          }}
          onSelectionChange={(rows) => {
            if (rows.length > 1) {
              setEnableComment(true);
            } else {
              setEnableComment(false);
            }
          }}
        />
      </div>
      {/* </Container> */}
      <LandingPageFooter />
      <Popup
        title="Physical Inventory"
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
      >
        <PhysicalInventoryForm
          recordForEdit={recordForEdit}
          editPhysicalInventory={editPhysicalInventory}
          addOrEdit={addOrEdit}
          storeid={storeId}
          userid={userId}
        />
      </Popup>
      <ConfirmationDialog
        title="Scanned item is a prescription product."
        openDialog={openRxDialog}
        closeDialog={setOpenRxDialog}
        popupTitle="Physical Inventory"
        onSubmit={onRxOkButtonClick}
        OkButtonText="Enter Manually"
        CancelButtonText="Scan Matrix Data"
        onCancel={() => {
          setPhysicalInventoryData({
            ...physicalInventoryData,
            barcode: "",
          });
          setOpenRxDialog(false);
        }}
        showCloseButton={true}
      />
      <Popup
        title="Physical Inventory - Manual"
        openPopup={openManualOTCPopup}
        setOpenPopup={setOpenManualOTCPopup}
      >
        <Grid
          component="label"
          container
          alignItems="center"
          spacing={1}
          className={classes.switch}
        >
          <RadioGroup
            row
            aria-label="scan"
            name="row-radio-buttons-group"
            value={openOTCManualDialog ? "OTC" : "RX"}
            onChange={handleChecked}
          >
            <FormControlLabel
              default
              value="OTC"
              control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
              label="OTC"
            />
            <FormControlLabel
              value="RX"
              control={<Radio style={{ color: "rgb(22, 177, 255)" }} />}
              label="RX"
            />
          </RadioGroup>
        </Grid>
        {openOTCManualDialog ? (
          <AddManualOtcProductForm
            addOrEdit={addOrEditForManualOTC}
            recordForEdit={recordForEditForManualOTC}
            addOtcManualProduct={addOtcManualProduct}
            captureGoodsState={{
              store_id: storeId,
              ...physicalInventoryData,
            }}
          />
        ) : (
          <GoodReceivablePhysicalInventoryForm
            addOrEdit={addOrEditForManualRx}
            recordForEdit={recordForEditForManualRx}
            addPhysicalInventory={addPhysicalInventory}
            captureGoodsState={{
              store_id: storeId,
              ...physicalInventoryData,
            }}
          />
        )}
      </Popup>
      <Popup
        title="Physical Inventory - OTC"
        openPopup={openOTCPopup}
        setOpenPopup={setOpenOTCPopup}
      >
        <AddOtcProductForm
          addOrEdit={addOrEditOTC}
          recordForEdit={recordForEditOTC}
          addOtcProduct={addPhysicalInventoryOtcRxProduct}
          captureGoodsState={physicalInventoryData}
          showPartialFull
        />
      </Popup>
      <Popup
        title="Physical Inventory - Rx"
        openPopup={openRxPopup}
        setOpenPopup={setOpenRxPopup}
      >
        <AddRxProductForm
          addOrEdit={addOrEditForRx}
          recordForEdit={recordForEditForRx}
          addRxProduct={addRxProduct}
          captureGoodsState={physicalInventoryData}
        />
      </Popup>
      <CommentPopup
        title="Add Comments"
        openDialog={openCommentPopup}
        closeDialog={setOpenCommentPopup}
        comment={comment}
        onCommentChange={setComment}
        onSubmit={handleCommentSubmit}
        OkButtonText="Submit"
      />
      <ConfirmationDialog
        title="Do you want to proceed?"
        openDialog={openDeleteDialog}
        closeDialog={setOpenDeleteDialog}
        popupTitle="Physical Inventory"
        onSubmit={handleDelete}
      />
      <ConfirmationDialog
        openDialog={openReceivedInventoriesDialog}
        closeDialog={setOpenReceivedInventoriesDialog}
        title="Can you please Confirm?"
        popupTitle="Physical Inventory"
        onSubmit={enableDoubleConfirm}
        onCancel={onReceivedInventoriesCancelClick}
        CancelButtonText="Continue Scanning"
        OkButtonText="Create New session"
      />
      <ConfirmationDialog
        openDialog={openDoubleConfirmDialog}
        closeDialog={setOpenDoubleConfirmDialog}
        title="The scanned data will be deleted. Do you want to create new session?"
        popupTitle="Physical Inventory"
        onSubmit={onReceivedInventoriesOkButtonClick}
        onCancel={onReceivedInventoriesCancelClick}
        CancelButtonText="No"
        OkButtonText="Yes"
      />
      <ConfirmationDialog
        openDialog={openLocationDialog}
        closeDialog={setOpenLocationDialog}
        title="Do you want proceed with new Location?"
        popupTitle="Physical Inventory"
        onSubmit={onLocationOkButtonClick}
        hideCancel={true}
      />
      <ConfirmationDialog
        title="Do you want to create a new record for the barcode ?"
        openDialog={openDialog}
        closeDialog={setOpenDialog}
        popupTitle="Physical Inventory"
        onSubmit={onOkButtonClick}
      />
    </Container>
  );
}

const mapStateToDispatch = (state) => ({
  physicalInventories: state.captureGoodsResponse,
});

const mapDispatchToProps = (dispatch) => {
  return {
    editPhysicalInventory: (physicalInventory) =>
      dispatch(editPhysicalInventoryAction(physicalInventory)),
    addOtcManualProduct: (otcManualProduct) =>
      dispatch(addOtcManualProductAction(otcManualProduct)),
    addPhysicalInventoryOtcRxProduct: (physicalInventory) =>
      dispatch(addPhysicalInventoryRxOtcWithoutLotNoAction(physicalInventory)),
    addRxProduct: (rxProduct) =>
      dispatch(addPhysicalInventoryRxAction(rxProduct)),
    addPhysicalInventory: (physicalInventory) =>
      dispatch(addPhysicalInventoryManualRxAction(physicalInventory)),
  };
};

export default connect(
  mapStateToDispatch,
  mapDispatchToProps
)(PhysicalInventoryLandingPageWithoutLotNo);
